import * as React from 'react';



export default class Decending extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
          <g fill="none" fillRule="evenodd">
                <path fill="#000" d="M13.4 14.415l-.398-1.04h-2.565l-.398 1.04H9L11.127 9h1.185l2.127 5.415H13.4zm-1.68-4.611l-1.015 2.736h2.03L11.72 9.804z"/>
                <path fill="#43ADF1" d="M10 6.415v-.771l2.768-3.808H10V1h4.002v.771L11.234 5.58h2.825v.836z"/>
                <g stroke="#000" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M5.055 1.552v11.91M1.762 11.18l3.29 2.92 3.289-2.92"/>
                </g>
            </g>
      </svg>
    )
  }
}
